import client from '@/client';
var ROLE_ADMIN = "admin";
var ROLE_EDITOR = "editor";
var ROLE_USER = "user";
var ROLES_NOVA = [ROLE_ADMIN, ROLE_EDITOR];
var auth = {
    namespaced: true,
    state: function () {
        return { user: null };
    },
    getters: {
        auth: function (state) {
            return state.user != null;
        },
        user: function (state) {
            return state.user;
        },
        nova: function (state) {
            return state.user != null && (ROLES_NOVA.includes(state.user.role.key));
        },
        verified: function (state) {
            return state.user != null && state.user.verified;
        },
        granted: function (state) {
            return state.user != null && state.user.granted;
        },
    },
    mutations: {
        login: function (state, user) {
            state.user = user;
        },
        logout: function (state) {
            state.user = null;
        },
        update: function (state, user) {
            state.user = user;
        }
    },
    actions: {
        login: function (context, data) {
            return client.get('/sanctum/csrf-cookie')
                .then(function (result) {
                console.log('CSRF token fetched');
                return client.post('/api/account/session', data);
            })
                .then(function (result) {
                console.log('API token fetched');
                return client.get('/api/account');
            })
                .then(function (result) {
                console.log('User data fetched');
                context.commit('login', result.data.data);
                return context.dispatch('context/setup', null, { root: true });
            })
                .then(function (result) {
                console.log('Context setup after login');
                return Promise.resolve();
            })
                .catch(function (error) {
                console.log('Logging in failed');
                context.commit('logout');
                return Promise.reject(error.response.data);
            });
        },
        logout: function (context) {
            return client.delete('/api/account/session')
                .then(function (result) {
                console.log('User session termninated');
                context.commit('logout');
                return Promise.resolve();
            })
                .catch(function (error) {
                console.log('User session not terminated');
                context.commit('logout');
                return Promise.reject(error.response.data);
            });
        },
        lockout: function (context) {
            console.log('User session terminated');
            context.commit('logout');
        },
        setup: function (context, data) {
            return client.get('/sanctum/csrf-cookie')
                .then(function (result) {
                console.log('CSRF token fetched');
                return client.post('/api/account', data);
            })
                .then(function (response) {
                console.log('User account created');
                return Promise.resolve(response.data);
            })
                .catch(function (error) {
                console.log('User account not created');
                return Promise.reject(error.response.data);
            });
        },
        resend: function (context) {
            return client.post('/api/account/email:resend')
                .then(function (response) {
                console.log('Confirmation email request sent');
                return Promise.resolve(response.data.data);
            })
                .catch(function (error) {
                console.log('Confirmation code request failed');
                return Promise.reject(error.response.data);
            });
        },
        verify: function (context, data) {
            var params = [data.data.id, data.data.hash].join('/');
            var target = '/api/email/verify/' + params;
            return client.get(target, { params: data.query })
                .then(function (response) {
                console.log('Email verified successfully');
                return client.get('/api/account');
            })
                .then(function (response) {
                console.log('User account data refreshed');
                context.commit('update', response.data.data);
                return Promise.resolve(response.data.data);
            })
                .catch(function (error) {
                console.log('Email verification failed');
                return Promise.reject(error.response.data);
            });
        },
        update: function (context, data) {
            return client.put('/api/account', data)
                .then(function (response) {
                console.log('User account updated');
                return client.get('/api/account');
            })
                .then(function (response) {
                console.log('User account data refreshed');
                context.commit('update', response.data.data);
                return Promise.resolve(response.data.data);
            })
                .catch(function (error) {
                console.log('User account update failed');
                return Promise.reject(error.response.data);
            });
        },
        reload: function (context) {
            return client.get('/api/account')
                .then(function (result) {
                console.log('User data fetched');
                context.commit('login', result.data.data);
                return Promise.resolve();
            })
                .catch(function (error) {
                console.log('Fetching user failed');
                context.commit('logout');
                return Promise.reject(error.response.data);
            });
        },
    },
};
export default auth;
